module.exports = {
	trackEvents: function (chartName, chart) {
		if (chart.scrollbarX) {
			chart.scrollbarX.events.on('down', function () {
				var data = {
					'event': 'GraphScrollbar',
					'chartTitle': chartName
				};
				window.tracking.trackEvent(data);
			});
		}

		if (chart.xAxes && chart.xAxes.values[0]) {
			chart.xAxes.values[0].tooltip.events.on('shown', function () {
				var data = {
					'event': 'GraphTooltip',
					'chartTitle': chartName
				};
				window.tracking.trackEvent(data);
			});
		}
	},
	trackYearSlider: function (yearSlider, chartName) {
		yearSlider.events.on('down', function () {
			var data = {
				'event': 'GraphSlider',
				'chartTitle': chartName
			};
			window.tracking.trackEvent(data);
		});
	},
	trackColumnSeriesTooltip: function(columnSeries, chartName) {
		if (!sessionStorage.tooltipCount) {
			sessionStorage.tooltipCount = 0;
		}

		columnSeries.tooltip.events.on('shown',
			function () {
				if (parseInt(sessionStorage.tooltipCount) < 20) {
					var data = {
						'event': 'GraphTooltip',
						'chartTitle': chartName
					};
					window.tracking.trackEvent(data);
					sessionStorage.tooltipCount++;
				}
			});
	}
};
